import AuthenticatedComponent from "../../base/AuthenticatedComponent/AuthenticatedComponent";
import SubmitReportState, {
  StudentCourseDailyReportView,
  SubmitReportProps,
  ValueChangerEnum,
} from "./SubmitReport.models";
import "./SubmitReport.scss";
import { ReactNode } from "react";
import SubmitReportImage from "../../../assest/images/card-image/Item-Avatar01.png";
import { TitleValueView } from "../register-report/RegisterReport.models";
import RegisterReport from "../register-report/RegisterReport";
import ReportErrorHandlerModal from "../report-error-handler-modal/ReportErrorHandlerModal";
import ConfirmReportModal from "../confirm-report-modal/ConfirmReportModal";
import { toast } from "react-toastify";

export default class SubmitReport extends AuthenticatedComponent<
  SubmitReportProps,
  SubmitReportState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      sleepAtHour: null,
      sleepAtMinute: null,
      wakeUpAtHour: null,
      wakeUpAtMinute: null,
      electronicUsageAtHour: null,
      electronicUsageAtMinute: null,
      courses: [],
      satisfied: true,
      showForm: false,
      notValidCourses: [],
      showConfirmModal: false,
      showValidateModal: false,
    };
  }

  replacer = (e: any) => {
    var inner = e.toString();
    inner = inner.replace("+", "");
    inner = inner.replace("-", "");
    inner = inner.replace(".", "");
    if (inner === null || inner === "") return 0;

    return Number.parseInt(inner);
  };

  addError = (studentCourseDailyReport: StudentCourseDailyReportView) => {
    var textResult = "";
    var studyTimehour = "";
    var studyTimeMinute = "";
    var testPassedCount = "";

    if (
      studentCourseDailyReport.studyTimeHour === null ||
      studentCourseDailyReport.studyTimeMinute === null
    ) {
      studyTimehour = "لطفا میزان مطالعه خود را وارد کنید";
    }

    if (
      studentCourseDailyReport.studyTimeHour !== null &&
      (studentCourseDailyReport.studyTimeHour < 0 ||
        studentCourseDailyReport.studyTimeHour > 23)
    ) {
      studyTimehour = "لطفا ساعت مطالعه خود را به درستی وارد کنید.";
    }

    if (
      studentCourseDailyReport.studyTimeMinute !== null &&
      (studentCourseDailyReport.studyTimeMinute < 0 ||
        studentCourseDailyReport.studyTimeMinute > 59)
    ) {
      studyTimeMinute = "لطفا دقیقه مطالعه خود را به درستی وارد کنید.";
    }

    if (
      textResult !== "" ||
      studyTimehour !== "" ||
      studyTimeMinute !== "" ||
      testPassedCount !== ""
    ) {
      let notValidCourses = this.state.notValidCourses;
      notValidCourses.push({
        courseID: studentCourseDailyReport.courseID,
        courseTitle: studentCourseDailyReport.courseTitle,
        studyTextResultError: textResult,
        studyTimeMinuteError: studyTimeMinute,
        studyTimeHourError: studyTimehour,
        testPassedCountError: testPassedCount,
      });

      this.setState({
        notValidCourses: notValidCourses,
      });
    }
  };

  handleInput = (
    course: StudentCourseDailyReportView,
    value: string,
    type: ValueChangerEnum
  ) => {
    var courses = this.state.courses;
    let index = courses.indexOf(course);
    switch (type) {
      case ValueChangerEnum.studyTimeHour:
        course.studyTimeHour = Number.parseInt(value);
        break;
      case ValueChangerEnum.studyTimeMinute:
        course.studyTimeMinute = Number.parseInt(value);
        break;
      case ValueChangerEnum.testPassedCount:
        course.testPassedCount = Number.parseInt(value);
        break;
      case ValueChangerEnum.studyTextResult:
        course.studyTextResult = value;
        break;
      default:
        break;
    }
    courses[index] = course;
    this.setState({ courses: courses });
    this.forceUpdate();
  };

  getData = (data: TitleValueView<number>[]) => {
    let courses = data.map((item) => ({
      courseID: item.value,
      courseTitle: item.title,
      studyTimeHour: 0,
      studyTimeMinute: 0,
      testPassedCount: 0,
      studyTextResult: "",
    }));

    this.setState({ courses: courses, showForm: true });
  };

  validateForm = () => {
    let {
      sleepAtHour,
      sleepAtMinute,
      wakeUpAtHour,
      wakeUpAtMinute,
      electronicUsageAtHour,
      electronicUsageAtMinute,
    } = this.state;

    this.state.courses.map((course) => this.addError(course));

    if (wakeUpAtHour == null || wakeUpAtMinute == null)
      toast.error("لطفا ساعت بیداری خود را وارد کنید.");
    else if (sleepAtHour == null || sleepAtMinute == null)
      toast.error("لطفا ساعت خواب خود را وارد کنید.");
    else if (electronicUsageAtHour == null || electronicUsageAtMinute == null)
      toast.error("لطفا میزان استفاده از فضای مجازی خود را وارد کنید.");
    else if (this.state.notValidCourses.length > 0)
      this.setState({ showValidateModal: true });
    else this.setState({ showConfirmModal: true });
  };

  closeValidateModal = () => {
    this.setState({ showValidateModal: false, notValidCourses: [] });
  };

  showList = () => {
    this.setState({ showForm: false });
  };

  handleTestCount = (valuePlus: number, value?: number | null): number => {
    value = value ?? 0;
    value += valuePlus;

    value = value < 0 ? 0 : value;

    return value;
  };

  closeConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  render(): ReactNode {
    let {
      courses,
      satisfied,
      showForm,
      showConfirmModal,
      sleepAtHour,
      sleepAtMinute,
      electronicUsageAtHour,
      electronicUsageAtMinute,
      wakeUpAtHour,
      wakeUpAtMinute,
      showValidateModal,
      notValidCourses,
    } = this.state;

    return (
      <>
        {this.contentRender(courses, satisfied, showForm)}

        <ReportErrorHandlerModal
          closeModal={this.closeValidateModal}
          showModal={showValidateModal}
          notValidCourses={notValidCourses}
        />
        <ConfirmReportModal
          sleepTime={{ hour: sleepAtHour ?? 0, minute: sleepAtMinute ?? 0 }}
          wakeUpTime={{ hour: wakeUpAtHour ?? 0, minute: wakeUpAtMinute ?? 0 }}
          electronicUsageTime={{
            hour: electronicUsageAtHour ?? 0,
            minute: electronicUsageAtMinute ?? 0,
          }}
          courses={courses}
          isLiked={satisfied}
          closeModal={this.closeConfirmModal}
          showModal={showConfirmModal}
        />
      </>
    );
  }

  contentRender(
    courses: StudentCourseDailyReportView[],
    satisfied: boolean,
    showForm: boolean
  ) {
    let content;
    if (showForm)
      content = (
        <div className="background-content submit-report-area">
          {this.headerView()}
          <div className="content-menu" style={{ height: "auto" }}>
            <div className="col-12">{this.sleepingTimeView()}</div>
            <div className="assessment">{this.courseListView(courses)}</div>
            {this.footerView(satisfied)}
          </div>
        </div>
      );
    else content = <RegisterReport afterSelect={this.getData} />;

    return <>{content}</>;
  }

  headerView() {
    return (
      <div className="tk-header-menu">
        <label className="mdi mdi-arrow-left" onClick={this.showList}></label>
      </div>
    );
  }

  sleepingTimeView = () => {
    let {
      sleepAtHour,
      sleepAtMinute,
      wakeUpAtHour,
      wakeUpAtMinute,
      electronicUsageAtHour,
      electronicUsageAtMinute,
    } = this.state;

    return (
      <div
        className="tk-card"
        style={{ marginTop: "18px", marginBottom: "18px" }}
      >
        <div style={{ padding: "18px" }}>
          <div className="tk-inline">
            <div className="col-8 notspace">
              <label>ساعت بیداری</label>
            </div>
            <div
              className=" col-4 notspace row-action"
              style={{ paddingRight: "10px !important" }}
              dir="ltr"
            >
              <input
                maxLength={2}
                className="tk-aling-center time-numeric-input"
                inputMode="numeric"
                onChange={(e) =>
                  this.setState({
                    wakeUpAtMinute: this.replacer(e.target.value),
                  })
                }
                value={wakeUpAtMinute ?? ""}
                placeholder="00"
                id="hours"
              />
              <label> : </label>
              <input
                maxLength={2}
                className="tk-aling-center time-numeric-input"
                inputMode="numeric"
                value={wakeUpAtHour ?? ""}
                onChange={(e) =>
                  this.setState({ wakeUpAtHour: this.replacer(e.target.value) })
                }
                placeholder="07"
                id="min"
              />
            </div>
          </div>
          <div className="tk-inline" style={{ marginTop: "10px" }}>
            <div className="col-8 notspace">
              <label>ساعت خواب</label>
            </div>
            <div
              className=" col-4 notspace row-action"
              style={{ paddingRight: "10px !important" }}
              dir="ltr"
            >
              <input
                maxLength={2}
                className="tk-aling-center time-numeric-input"
                inputMode="numeric"
                value={sleepAtMinute ?? ""}
                onChange={(e) =>
                  this.setState({
                    sleepAtMinute: this.replacer(e.target.value),
                  })
                }
                placeholder="00"
                id="hours"
              />
              <label> : </label>
              <input
                maxLength={2}
                className="tk-aling-center time-numeric-input"
                inputMode="numeric"
                value={sleepAtHour ?? ""}
                onChange={(e) =>
                  this.setState({ sleepAtHour: this.replacer(e.target.value) })
                }
                placeholder="22"
                id="min"
              />
            </div>
          </div>
          <div className="tk-inline" style={{ marginTop: "10px" }}>
            <div className="col-8 notspace">
              <label>میزان استفاده از فضای مجازی</label>
            </div>
            <div
              className=" col-4 notspace row-action"
              style={{ paddingRight: "10px !important" }}
              dir="ltr"
            >
              <input
                maxLength={2}
                className="tk-aling-center time-numeric-input"
                inputMode="numeric"
                value={electronicUsageAtMinute ?? ""}
                onChange={(e) =>
                  this.setState({
                    electronicUsageAtMinute: this.replacer(e.target.value),
                  })
                }
                placeholder="00"
                id="min"
              />
              <label> : </label>
              <input
                maxLength={2}
                className="tk-aling-center time-numeric-input"
                inputMode="numeric"
                value={electronicUsageAtHour ?? ""}
                onChange={(e) =>
                  this.setState({
                    electronicUsageAtHour: this.replacer(e.target.value),
                  })
                }
                placeholder="01"
                id="hours"
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  footerView(satisfied: boolean) {
    return (
      <div className="col-12">
        <div
          className="tk-card"
          style={{ marginTop: "18px", marginBottom: "18px" }}
        >
          <div className="assessment-title">
            <label>ارزیابی کلی مطالعه :</label>
          </div>
          <div className="col-12 assessment-content">
            <div className="tk-inline">
              <div
                className={
                  "col-6 notspace tk-inline " + (satisfied ? "active" : "")
                }
                onClick={() => this.setState({ satisfied: true })}
              >
                <div className="thumb">
                  <span>
                    <i
                      className="mdi mdi-thumb-up"
                      style={{ color: "#34a853" }}
                    ></i>
                  </span>
                </div>
                <label className="satisfied-title">از عملکردم راضی‌ام</label>
              </div>
              <div
                className={
                  "col-6 notspace tk-inline " + (!satisfied ? "active" : "")
                }
                onClick={() => this.setState({ satisfied: false })}
              >
                <div className="thumb">
                  <span>
                    <i
                      className="mdi mdi-thumb-down"
                      style={{ color: "#ea4335" }}
                    ></i>
                  </span>
                </div>
                <label className="satisfied-title">از عملکردم ناراضی‌ام</label>
              </div>
            </div>
          </div>
        </div>
        <div className="submit">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={this.validateForm}
          >
            ثبت گزارش
          </button>
        </div>
      </div>
    );
  }

  courseListView(courses: StudentCourseDailyReportView[]) {
    return (
      <>
        {courses.map((course, key) => {
          return (
            <div key={key} className="col-12">
              <div className="tk-card">
                <div className="card-icon">
                  <img src={SubmitReportImage} alt="submit report icon" />
                </div>
                <div className="card-title">
                  <label>{course.courseTitle} </label>
                </div>
                <div className="col-12">
                  <div className="tk-inline">
                    <div className="col-6 notspace">
                      <label>میزان مطالعه</label>
                    </div>
                    <div
                      className=" col-6 notspace row-action"
                      style={{ paddingRight: "10px !important" }}
                      dir="ltr"
                    >
                      <input
                        maxLength={2}
                        className="tk-aling-center time-numeric-input"
                        inputMode="numeric"
                        value={course.studyTimeMinute ?? ""}
                        onChange={(e) =>
                          this.handleInput(
                            course,
                            this.replacer(e.target.value).toString(),
                            ValueChangerEnum.studyTimeMinute
                          )
                        }
                        placeholder="45"
                        id="min"
                      />
                      <label> : </label>
                      <input
                        maxLength={2}
                        className="tk-aling-center time-numeric-input"
                        inputMode="numeric"
                        value={course.studyTimeHour ?? ""}
                        onChange={(e) =>
                          this.handleInput(
                            course,
                            this.replacer(e.target.value).toString(),
                            ValueChangerEnum.studyTimeHour
                          )
                        }
                        placeholder="17"
                        id="hours"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="tk-inline">
                    <div className="col-6 notspace">
                      <label>تعداد تست</label>
                    </div>
                    <div className=" col-6 notspace row-action">
                      <label
                        className="icon-plus"
                        onClick={() =>
                          this.handleInput(
                            course,
                            this.handleTestCount(
                              +1,
                              course.testPassedCount
                            ).toString(),
                            ValueChangerEnum.testPassedCount
                          )
                        }
                      >
                        <i className="mdi mdi-plus"></i>
                      </label>
                      <input
                        className="tk-aling-center tk-margin time-numeric-input"
                        inputMode="numeric"
                        placeholder="20"
                        value={course.testPassedCount ?? ""}
                        min="0"
                        onChange={(e) =>
                          this.handleInput(
                            course,
                            this.replacer(e.target.value).toString(),
                            ValueChangerEnum.testPassedCount
                          )
                        }
                      />
                      <label
                        className="icon-minus"
                        onClick={() =>
                          this.handleInput(
                            course,
                            this.handleTestCount(
                              -1,
                              course.testPassedCount
                            ).toString(),
                            ValueChangerEnum.testPassedCount
                          )
                        }
                      >
                        <i className="mdi mdi-minus"></i>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="study-result">
                    <input
                      style={{
                        borderBottom: " 1px solid #8898aa",
                        borderColor: "#8898aa !important",
                        padding: "0",
                        outline: "none",
                      }}
                      className="tk-form-controll"
                      value={course.studyTextResult}
                      onChange={(e) =>
                        this.handleInput(
                          course,
                          e.target.value,
                          ValueChangerEnum.studyTextResult
                        )
                      }
                      placeholder="نتیجه مطالعه"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  }
}
